import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lyrics"
export default class extends Controller {
  static targets = ["content", "icon", "button"]

  connect() {
    // Initialize in collapsed state
    this.collapsed = true
  }

  toggle() {
    this.collapsed = !this.collapsed
    
    if (this.collapsed) {
      // Collapse
      this.contentTarget.style.maxHeight = "0px"
      this.iconTarget.style.transform = "rotate(0deg)"
      this.buttonTarget.querySelector('span').textContent = "View Lyrics"
    } else {
      // Expand
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      this.iconTarget.style.transform = "rotate(180deg)"
      this.buttonTarget.querySelector('span').textContent = "Hide Lyrics"
    }
  }
}
